import { API_BASE_URL } from '../client';

export const PERMISSION_ENDPOINTS = {
  PERMISSION_CONFIG: {
    BASE: `${API_BASE_URL}/PermissionConfig`,
    MY_PERMISSION_CODES: `${API_BASE_URL}/PermissionConfig/my-permission-codes`,
    ME: `${API_BASE_URL}/PermissionConfig/me`,
    ROLES: `${API_BASE_URL}/PermissionConfig/roles`,
    USERS: `${API_BASE_URL}/PermissionConfig/users`,
    MUTABLE_USERS: `${API_BASE_URL}/PermissionConfig/mutable-users`,
    UPSERT_ROLE: `${API_BASE_URL}/PermissionConfig/role`,
    UPSERT_USER: `${API_BASE_URL}/PermissionConfig/user`,
    DELETE_ROLE: (roleCode: string) => `${API_BASE_URL}/PermissionConfig/role/${encodeURIComponent(roleCode)}`,
    DELETE_USER: (userId: number) => `${API_BASE_URL}/PermissionConfig/user/${userId}`,
  },
} as const;
